export enum ChargesStatusColorEnum {
    TREATED = '#16CCC3',
    NOT_TREATED = '#DC4C64',
    REFUSED = '#DC4C4C',
    APPROVED = '#1781A1',
    WAITING_APPROVAL= '#E2B434'
}
